import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

export default {
  getAutoList(params) { //获取订单列表
    const url =  baseURL + '/tbAuthorizedproduct/getList';
    return axios.post(url, qs.stringify(params));
  },
  delAutoList(params) { //禁用
    const url =  baseURL + '/tbAuthorizedproduct/productOperate';
    return axios.post(url, qs.stringify(params));
  },
  autoDetail(params) { //产品续费
    const url =  baseURL + '/tbAuthorizedproduct/productRenew';
    return axios.post(url, qs.stringify(params));
  },
  
  autoOrder(params) { //续费订单
    const url =  baseURL + '/tbOrder/renewOrder';
    return axios.post(url, qs.stringify(params));
  },

  getDetailByAuthProductId(params) { //相关订单
    const url =  baseURL + '/tbOrder/getDetailByAuthProductId';
    return axios.post(url, qs.stringify(params));
  },
  
  //客户留言新增
  addUserNote(params){
    const url =  baseURL + '/tbUserNote/add';
    return axios.post(url, qs.stringify(params));
  },
  //获取客户留言信息
  getUserNote(params){
    const url =  baseURL + '/tbUserNote/list';
    return axios.post(url, qs.stringify(params));
  }
  
}


// WEBPACK FOOTER //
// ./src/api/authorize.js